import { useState, useEffect } from "react";
import InputFilter from "../../components/GInput/InputFilter";
import DropDownFilter from "../../components/GDropDownList/DropDownFilter";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DropDownFilterPaginationsMulti from "../../components/GDropDownList/DropDownFilterPaginationsMulti";

export default function ReportsFilter ({reportType, usersData, search, values}) {

    const location = useLocation(); 
    const [value, setValue] = useState({});
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    useEffect(() => {

        const updatedValue = values.reduce((acc, item) => ({
            user_id: item.user_id || acc.user_id || "",
            from_date: item.from_date || acc.from_date || "",
            to_date: item.to_date || acc.to_date || "",
            type: item.type || acc.type || "",
        }), {
            user_id: "",
            from_date: "",
            to_date: "",
            type: "",
        });
        
        setValue(updatedValue);
        
    }, [values]);

    const handleValues = (key, v) => {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        searchParams.delete(key);

        const newUrl = `${url.pathname}?${searchParams.toString()}${url.hash}`;
        
        navigate(newUrl, { replace: true });

        setValue(prev => ({
            ...prev,
            [key]: ""
        }));
    };

    return (<>
        <div className=" bg-thirdly rounded-t-lg px-5 py-3">
            <div className="py-2 flex flex-row justify-between items-center">
                <p className="text-[22px] text-left font-semibold text-white">{currentLang === "en" ? "Filters" : "الفلاتر"}</p>
            </div>
            <div className="flex flex-col py-2 gap-4">
                <div className="flex sm:flex-row flex-col justify-center items-center gap-4">
                    {!location.pathname.startsWith("/users/details/") &&
                        <div className="w-full">
                            <DropDownFilterPaginationsMulti search={search} options={usersData} value={value.user_id} defaultText={t("filters.user")} paramkey="user_id" />
                        </div>
                    }  
                    <div className="w-full">
                        <DropDownFilter options={reportType} value={value.type} defaultText={t("filters.type")} paramkey="type" />
                    </div>
                    <div className="w-full">
                        <InputFilter placeholder={"من الوقت"} type={"date"} paramkey="from_date"/>
                    </div>
                    <div className="w-full">
                        <InputFilter placeholder={"الى الوقت"} type={"date"} paramkey="to_date"/>
                    </div>
                </div>
                <div className="flex flex-row flex-wrap justify-end items-center gap-5">
                    {Object.entries(value).map(([key, v]) => ( 
                        v != "" && <div className="bg-gray-600 text-white flex justify-between items-center gap-3 rounded-lg text-md px-3 py-[2px]"><button onClick={() => handleValues(key, v)} className="bg-red-500 w-4 h-4 rounded-full text-sm text-white text-bold flex justify-center items-center">X</button> {key}: {String(v)} </div>
                    ))}
                </div>
            </div>
        </div>
    </>)
}